"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paletteSuccess = exports.paletteSoftDeletedList = exports.paletteSoftDeleteRestore = exports.paletteSoftDelete = exports.paletteRename = exports.paletteList = exports.paletteError = exports.paletteDelete = exports.paletteBulkSoftDelete = exports.paletteBulkRestore = exports.paletteBulkHardDelete = exports.paletteAdd = void 0;
var _palette = require("./palette.constant");
// @flow

// common success
var paletteSuccess = function paletteSuccess(actionType, data) {
  return {
    type: _palette.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.paletteSuccess = paletteSuccess;
var paletteError = function paletteError(actionType, error) {
  return {
    type: _palette.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get list of data.
 */
exports.paletteError = paletteError;
var paletteList = function paletteList(data) {
  return {
    type: _palette.actionTypes.LIST,
    payload: data
  };
};

/**
 * add
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
exports.paletteList = paletteList;
var paletteAdd = function paletteAdd(data) {
  return {
    type: _palette.actionTypes.ADD,
    payload: data
  };
};

/**
 * rename
 * @param payload
 * @returns api response
 * @description this function used to rename data.
 */
exports.paletteAdd = paletteAdd;
var paletteRename = function paletteRename(data) {
  return {
    type: _palette.actionTypes.RENAME,
    payload: data
  };
};

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to dalete data.
 */
exports.paletteRename = paletteRename;
var paletteDelete = function paletteDelete(data) {
  return {
    type: _palette.actionTypes.DELETE,
    payload: data
  };
};

/**
 * soft delete
 * @param payload
 * @returns api response
 * @description this function used to soft dalete data.
 */
exports.paletteDelete = paletteDelete;
var paletteSoftDelete = function paletteSoftDelete(data) {
  return {
    type: _palette.actionTypes.SOFT_DELETE,
    payload: data
  };
};

/**
 * soft delete restore
 * @param payload
 * @returns api response
 * @description this function used to soft dalete restore data.
 */
exports.paletteSoftDelete = paletteSoftDelete;
var paletteSoftDeleteRestore = function paletteSoftDeleteRestore(data) {
  return {
    type: _palette.actionTypes.SOFT_DELETE_RESTORE,
    payload: data
  };
};

/**
 * soft deleted list
 * @param payload
 * @returns api response
 * @description this function used to soft daleted list data.
 */
exports.paletteSoftDeleteRestore = paletteSoftDeleteRestore;
var paletteSoftDeletedList = function paletteSoftDeletedList(data) {
  return {
    type: _palette.actionTypes.SOFT_DELETED_LIST,
    payload: data
  };
};

/**
 * bulk soft deleted
 * @param payload
 * @returns api response
 * @description this function used to bulk soft dalete data.
 */
exports.paletteSoftDeletedList = paletteSoftDeletedList;
var paletteBulkSoftDelete = function paletteBulkSoftDelete(data) {
  return {
    type: _palette.actionTypes.BULK_SOFT_DELETE,
    payload: data
  };
};

/**
 * bulk hard deleted
 * @param payload
 * @returns api response
 * @description this function used to bulk hard dalete data.
 */
exports.paletteBulkSoftDelete = paletteBulkSoftDelete;
var paletteBulkHardDelete = function paletteBulkHardDelete(data) {
  return {
    type: _palette.actionTypes.BULK_HARD_DELETE,
    payload: data
  };
};

/**
 * bulk restore
 * @param payload
 * @returns api response
 * @description this function used to bulk restore data.
 */
exports.paletteBulkHardDelete = paletteBulkHardDelete;
var paletteBulkRestore = function paletteBulkRestore(data) {
  return {
    type: _palette.actionTypes.BULK_RESTORE,
    payload: data
  };
};
exports.paletteBulkRestore = paletteBulkRestore;